import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { JwtResponse } from 'src/app/interfaces/jwt';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const user: JwtResponse = JSON.parse(localStorage.getItem('currentUser') || 'null');
    if (user && user.role === 'admin') return true;
    this.router.navigate(['/acceder']);
    return false;
  }
}
